import { useState } from 'react';
import Nav from '../components/Nav';
import AppCard from '../components/AppCard';

const APPS = [
  {
    id: 'imin',
    name: 'ImIn',
    featured: true,
    image: null, // 이미지 준비되면: '/images/imin-screenshot.png'
    desc: {
      ko: '크리에이터와 팬을 잇는 투명한 추첨 플랫폼. 누가 당첨됐는지 모두가 볼 수 있습니다.',
      en: 'A transparent raffle platform connecting creators and fans. Everyone can see who won.',
    },
    link: 'https://imin.run',
    linkLabel: 'imin.run →',
  },
  
  {
    id: 'app2',
    name: '앱 2',
    coming: true,
    desc: { ko: '곧 공개됩니다.', en: 'In the works.' },
  },
  {
    id: 'app3',
    name: '앱 3',
    coming: true,
    desc: { ko: '곧 공개됩니다.', en: 'In the works.' },
  },
  {
    id: 'app4',
    name: '앱 4',
    coming: true,
    desc: { ko: '곧 공개됩니다.', en: 'In the works.' },
  },
  { id: 'ph', placeholder: true },
];

export default function Home() {
  const [lang, setLang] = useState('ko');

  return (
    <>
      <Nav lang={lang} setLang={setLang} />

      <main style={styles.main}>

        {/* 만든 것들 */}
        <section style={styles.apps}>
          <p style={styles.sectionLabel}>
            {lang === 'ko' ? '만든 것들' : "What we've made"}
          </p>
          <div style={styles.grid}>
            {APPS.map(app => (
              <AppCard key={app.id} app={app} lang={lang} />
            ))}
          </div>
        </section>

        {/* Contact */}
        <section style={styles.contact}>
          <p style={styles.contactLabel}>Contact</p>
          <div>
            <p style={styles.contactDesc}>
              {lang === 'ko'
                ? '아이디어가 있거나, 같이 무언가를 만들고 싶다면 편하게 연락 주세요.'
                : 'Have an idea or want to collaborate? Feel free to reach out.'}
            </p>
            <span style={styles.contactEmail}>hello@nuhpul.com</span>
            <a href="mailto:hello@nuhpul.com" style={styles.contactCta}>
              {lang === 'ko' ? '메일 보내기 ↗' : 'Send a message ↗'}
            </a>
          </div>
        </section>

      </main>

      <footer style={styles.footer}>
        <span style={styles.footerL}>
          {lang === 'ko' ? '© 2025 너풀너풀 스튜디오' : '© 2025 Nuhpul Studio'}
        </span>
        <span style={styles.footerR}>
          {lang === 'ko' ? '작은 것들을 꾸준히' : 'Small things, steadily'}
        </span>
      </footer>
    </>
  );
}

const styles = {
  main: {
    maxWidth: '960px',
    margin: '0 auto',
    padding: '0 3rem 6rem',
  },
  apps: {
    paddingTop: '4rem',
  },
  sectionLabel: {
    fontFamily: 'var(--mono)',
    fontSize: '.6rem',
    letterSpacing: '.2em',
    textTransform: 'uppercase',
    color: 'var(--ink-soft)',
    marginBottom: '1.5rem',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '1.2rem',
  },
  contact: {
    paddingTop: '5rem',
    borderTop: '1px solid var(--ink-pale)',
    marginTop: '5rem',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '2rem',
    alignItems: 'start',
  },
  contactLabel: {
    fontFamily: 'var(--mono)',
    fontSize: '.6rem',
    letterSpacing: '.2em',
    textTransform: 'uppercase',
    color: 'var(--ink-soft)',
    paddingTop: '.25rem',
  },
  contactDesc: {
    fontSize: '.93rem',
    fontWeight: 300,
    lineHeight: 2.1,
    color: 'var(--ink-mid)',
  },
  contactEmail: {
    fontFamily: 'var(--serif)',
    fontSize: 'clamp(1.2rem, 2vw, 1.6rem)',
    fontWeight: 200,
    fontStyle: 'italic',
    color: 'var(--ink)',
    marginTop: '1.8rem',
    display: 'block',
  },
  contactCta: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '.5rem',
    marginTop: '1.4rem',
    fontFamily: 'var(--mono)',
    fontSize: '.62rem',
    letterSpacing: '.12em',
    textTransform: 'uppercase',
    color: 'var(--ink)',
    textDecoration: 'none',
    borderBottom: '1px solid var(--ink-pale)',
    paddingBottom: '.15rem',
  },
  footer: {
    borderTop: '1.5px solid var(--ink)',
    padding: '.6rem 3rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  footerL: {
    fontFamily: 'var(--mono)',
    fontSize: '.58rem',
    letterSpacing: '.08em',
    color: 'var(--ink-soft)',
  },
  footerR: {
    fontFamily: 'var(--serif)',
    fontSize: '.8rem',
    fontStyle: 'italic',
    color: 'var(--ink-soft)',
  },
};
